<template>
    <div class="col-md-12 search result">
        <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible" width="80%">
            <el-table :data="gridData">
                <el-table-column property="DONO" label="DO No" width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.row.DONO === null">
                            <el-button @click="DONOClick(scope.row)" type="primary">Link Order</el-button>
                        </span>
                        <span v-else>{{ scope.row.DONO }}</span>
                    </template>
                </el-table-column>
                <el-table-column property="IDOrder" label="ID Order" width="200"></el-table-column>
                <el-table-column property="Remark" label="Remark" width="200"></el-table-column>
                <el-table-column property="TrxDate" label="Transaction Date" width="200"></el-table-column>
                <el-table-column property="Amount" label="Amount" align="left"></el-table-column>
            </el-table>
        </el-dialog>

        <BootstrapTable ref="table" class="table table-borderless table-hover table-striped no-border table-bs"
            :columns="columns" :data="rows" :options="table.config" @on-click-row="onselectrow" />

        <div class="toolbox" v-if="rows.length && !noxls">
            <vue-excel-xlsx class="btn icon btn-light btn-secondary justify-content-center" :data="dataXLSX"
                :columns="columnXLSX" :filename="reportname" :sheetname="'Data'">
                <i class="far fa-file-excel"></i>
            </vue-excel-xlsx>
        </div>

        <Loader v-if="loading" />

    </div>
</template>

<script>

import tableMixin from '../../mixins/table'
import '../../plugins/table.js'
import { AxiosWithJar, Config } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

import Vue from 'vue'
import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);


export default
    {
        mixins: [tableMixin],
        components: {
            Loader,
            //BootstrapTable,
        },
        props: ['reporturl', 'reportdata', 'reportname', 'rowtemplates', 'nopage', 'card_title', 'noxls', 'select_url', 'idcol', 'idcol2', 'loading'],
        data() {
            return {
                selectedRow: [],
                gridData: [],
                dialogTableVisible: false,
                table:
                {
                    config: {
                        pagination: !(this.nopage),
                        pageList: [10, 20, 50, 100, 'all'],
                        search: false,
                        showColumns: false,
                        showExport: false,

                        detailView: false, //card_mode
                        rows_selectable: true,

                        showFooter: false,
                    },
                    classes: {
                        table: "table-striped"
                    },
                },
                reportdata_: [],
            }
        },
        watch: {
            reporturl(now) {
                AxiosWithJar().get(now).then((response) => {
                    this.reportdata_ = response.data;
                })
            }
        },
        computed: {
            dialogTitle() {
                return "Brimola VA" + (this.selectedRow["DONO"] ? " | " + this.selectedRow["DONO"] : "") + (this.selectedRow["FinalTotal"] ? " - " + this.selectedRow["FinalTotal"] : "");
            },
            _reportdata() {
                return this.reportdata ? this.reportdata : this.reportdata_;
            },
            columns() {
                let cols = [];
                if (this._reportdata['columns']) {
                    let columns = this._reportdata['columns'];
                    for (var i = 0; i < columns.length; i++) {
                        if (columns[i].format != 'hidden') {
                            cols.push({
                                title: columns[i].title,
                                field: columns[i].field,
                                sortable: true,
                                align: columns[i].format == 'number' || columns[i].format == 'percent' || columns[i].format == 'decimal' ? "right" : "left",
                                valign: "middle",
                                sorter: columns[i].format == 'number' || columns[i].format == 'percent' || columns[i].format == 'decimal' ? this.numericOnly : this.alphanum, //'numericOnly',
                                formatter: this.cellFormatter,
                            });
                        }
                    }
                }
                //console.log('cols: '+JSON.stringify(cols));
                return cols;
            },
            rows() {
                let rows = [];
                if (this._reportdata['columns']) {
                    let columns = this._reportdata['columns'];
                    let data = this._reportdata['data'];
                    for (var j = 0; j < data.length; j++) {
                        let row = {}
                        for (var i = 0; i < columns.length; i++) {
                            let a = data[j][columns[i].field]
                            if (columns[i].format == 'number') a = this.formatNum(a * 1);
                            if (columns[i].format == 'percent') a = this.formatNum(a * 100) + "%";
                            row[columns[i].field] = a
                            //console.log('log: ' + a);
                        }
                        rows.push(row)
                    }
                }
                return rows;
            },
            columnXLSX() {
                let labels = [];
                if (this._reportdata['columns']) {
                    let columns = this._reportdata['columns'];
                    for (var i = 0; i < columns.length; i++) {
                        let dt = {}
                        dt['field'] = columns[i].field;
                        dt['label'] = columns[i].title;
                        labels.push(dt);
                    }
                }
                return labels;
            },
            dataXLSX() {
                let rows = [];
                if (this._reportdata['columns']) {
                    rows = this._reportdata['data'];
                }
                return rows;
            },

        },
        mounted() {
            if (this.card_title) {
                this.table.config.card_mode = true;
                this.table.config.card_title = this.card_title;
            }
        },
        methods: {
            DONOClick(row) {
                var urlRequestParams = Config().apiURL;
                var selectedRowTable = this.selectedRow;
                var userLogin = this.$store.getters.getUsername;
                this.$confirm('Anda yakin mengaitkan DO ini?' + selectedRowTable["DONO"] + ' -> ' + row.IDOrder)
                    .then(function(){
                        //alert(this.selectedRow["DONO"]);
                        urlRequestParams += '/v1/lpg/insertDOBrimolaClearing?IDOrder=' + row.IDOrder + '&DONo=' + selectedRowTable["DONO"] + '&userLogin=' + userLogin;
                        var amount = parseInt(row.Amount.replace(/,/g, ''));
                        var finalTotal = selectedRowTable["FinalTotal"].replace(/,/g, '');
                        var ntoleransi = parseInt(amount) - parseInt(finalTotal);
                        if (ntoleransi <= 5000 && ntoleransi >= 0) {
                            AxiosWithJar().get(urlRequestParams)
                                .then(() => {
                                    document.body.style.cursor = 'wait';
                                    this._reportdata['data'].forEach((rowx) => {
                                        if (rowx.DONO === selectedRowTable["DONO"]) {
                                            rowx.IDOrder = row.IDOrder;
                                            rowx.Status = "CLEAR"
                                            rowx.TrxDate = row.TrxDate;
                                            rowx.Remark = row.Remark;
                                            alert(row.Amount);
                                            rowx.Amount = amount;
                                        }
                                    });

                                    // Refresh the BootstrapTable component
                                    if (this.$refs.table) {
                                        this.$refs.table.refresh();
                                    }
                                    
                                    alert('Clearing berhasil!');
                                })
                                .catch((error) => {
                                    console.error('Error:', error);
                                })
                                .finally(() => {
                                    // Hide loading indicator and dialog
                                    this.dialogTableVisible = false;
                                    document.body.style.cursor = 'default';

                                    this.$alert('Clearing berhasil!', 'Message');
                                });
                        }
                        else {
                            if (ntoleransi > 5000) {
                                alert('Nilai toleransi maksimal 5000');
                            }
                            else {
                                alert('Nilai pembayaran dibawah harga DO');
                            }
                        }
                    })
                    .catch(function() { });
            }
            ,
            cellFormatter(value) {
                //var icon = row.id % 2 === 0 ? 'fa-star' : 'fa-star-and-crescent'
                let val = value

                if (value == null)
                    val = '-'

                if (value == 'OFFLINE' || value == 'CRITICAL')
                    val = '<span class="el-tag el-tag--small el-tag--danger el-tag--dark" style="margin-left:10px;">' + value + '</span>'
                else if (value == 'ONLINE')
                    val = '<span class="el-tag el-tag--small el-tag--dark" style="margin-left:10px;">' + value + '</span>'
                else if (value == 'NORMAL')
                    val = '<span class="el-tag el-tag--small el-tag--success el-tag--dark" style="margin-left:10px;">' + value + '</span>'
                else if (value == 'LOW')
                    val = '<span class="el-tag el-tag--small el-tag--warning el-tag--dark" style="margin-left:10px;">' + value + '</span>'

                return val
            },
            onselectrow(a) {
                document.body.style.cursor = 'wait';
                this.selectedRow = a;
                this.gridData = [];
                this.urlRequestParams = Config().apiURL;
                this.urlRequestParams += '/v1/lpg/getOrderBrimola?CustomerID=' + a[this.idcol2]
                AxiosWithJar().get(this.urlRequestParams)
                    .then((response) => {
                        this.gridData = response.data.data;
                        if (a["Status"] === 'NOT CLEAR') {
                            this.dialogTableVisible = true;
                        }
                    })
                    .catch()
                    .finally(() => {
                        document.body.style.cursor = 'default';
                    })

            },
            numericOnly(a, b) {
                function stripNonNumber(s) {
                    let decimalNumber = parseFloat(s.replace(/[^\d.]/g, ''));
                    let decimalNumberForceTwoComma = decimalNumber.toFixed(2); //.numberFormat(2);
                    //console.log('decimalNumber: '+ decimalNumber + '->decimalNumberForceTwoComma: ' +decimalNumberForceTwoComma);
                    s = decimalNumberForceTwoComma.replace(new RegExp(/[^0-9]/g), '');

                    //original source
                    //s = s.replace(new RegExp(/[^0-9]/g), '');
                    return parseInt(s, 10);
                }

                return stripNonNumber(a) - stripNonNumber(b);
            },
            //alphanum
            alphanum(a1, b1) {
                let a = a1
                let b = b1
                if (a1 == null)
                    a = 'z'
                if (b1 == null)
                    b = 'z'

                console.log('a: ' + a)
                console.log('b: ' + b)
                function chunkify(t) {
                    var tz = [];
                    var y = -1;
                    var n = 0;

                    for (var i = 0; i <= t.length; i++) {
                        var _char = t.charAt(i);

                        var charCode = _char.charCodeAt(0);

                        var m = charCode === 46 || charCode >= 48 && charCode <= 57;

                        if (m !== n) {
                            tz[++y] = '';
                            n = m;
                        }

                        tz[y] += _char;
                    }

                    return tz;
                }

                function stringfy(v) {
                    if (typeof v === 'number') {
                        v = "".concat(v);
                    }
                    if (!v) {
                        v = '';
                    }

                    return v;
                }

                var aa = chunkify(stringfy(a));
                var bb = chunkify(stringfy(b));

                for (var x = 0; aa[x] && bb[x]; x++) {
                    if (aa[x] !== bb[x]) {
                        var c = Number(aa[x]);
                        var d = Number(bb[x]);

                        if (c === aa[x] && d === bb[x]) {
                            return c - d;
                        }

                        return aa[x] > bb[x] ? 1 : -1;
                    }
                }

                return aa.length - bb.length;
            },
            //end alphanum
        }
    }
</script>
<style>
.table {
    --bs-table-striped-bg:
        /*rgba(0, 0, 0, 0.0)*/
        #FAFAFA !important;
    /**Remove if back to original color */
    --bs-table-hover-bg: rgba(0, 0, 0, 0.010) !important;
    /**Remove if back to original color */
}

.table-bs td {
    border-bottom: 1px solid #EBEEF5 !important;
    transition: background-color .25s ease;
    padding: 0.55rem 0.5rem !important;
    color: #606266 !important;
}

table.table {
    font-size: 14px;
}

table.table tr.vbt-table-tools {
    display: none;
}

table.table th {
    padding: 2px 10px !important;
}

table.table .form-group {
    margin-bottom: 0px;
}


.search.result {
    margin-top: 10px;
    background: rgba(20, 109, 182, .0275);
    border-radius: 5px 5px;
    color: #666;
    padding: 0px;
}

.search.result .toolbox {
    z-index: 99;
    position: fixed;
    bottom: 25px;
    right: 25px;
    display: flex;
    background: rgba(255, 255, 255, .75);
    border-radius: 25px;
}

.search.result .toolbox button {
    display: flex;
    font-size: 12px;
    align-items: center;
    background: rgba(20, 109, 182, .75) !important;
    color: #fff;
    border-radius: 15px;
}

.search.result .toolbox .btn.icon {
    padding: 15px;
    margin: 10px;
}

.no-border {
    border: 0px solid #fff !important;
}

/** TABLE PAGINATION */

.fixed-table-body {
    background: white !important;
}



.fixed-table-pagination {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 5px;
    padding-bottom: 5px;
    background: white !important;
}

.page-item.active .page-link {
    z-index: 3;
    color: #fff !important;
    background-color: #409EFF
        /*#0d6efd*/
        /*#c7251c*/
        !important;
    border-color: #409EFF
        /*#dee2e6*/
        !important;
}

.page-link {
    line-height: 1.3 !important;
    padding: 0.375rem 0.85rem !important;
    font-size: 14px;
    color: #606266
        /*#409EFF*/
        /*#0d6efd*/
        !important;
    margin-left: 10px;
    margin-right: 10px;
    border-radius: 2px;
    font-weight: bold;
    background-color: #f4f4f5 !important;
}

.btn.btn-secondary.dropdown-toggle {
    line-height: 1.3 !important;
    padding: 0.475rem 0.75rem !important;
    color: #fff !important;
    background-color: #409EFF
        /*#0d6efd*/
        !important;
}

.page-item:first-child .page-link {
    margin-left: 0;
    border-top-left-radius: 0.1rem !important;
    border-bottom-left-radius: 0.1rem !important;
    border-top-right-radius: 0.1rem !important;
    border-bottom-right-radius: 0.1rem !important;
    padding-top: 5px !important;
    padding-bottom: 7px !important;
    padding-left: 15px !important;
    padding-right: 15px !important;
}

.page-item:last-child .page-link {
    border-top-right-radius: 0.1rem !important;
    border-bottom-right-radius: 0.1rem !important;
    border-top-right-radius: 0.1rem !important;
    border-bottom-right-radius: 0.1rem !important;
    padding-top: 5px !important;
    padding-bottom: 7px !important;
    padding-left: 15px !important;
    padding-right: 15px !important;
}

/** END TABLE PAGINATION */
</style>